import { normalizeString as t } from "./string.utils.js";
const d = ({
  filterValue: n,
  options: e,
  getOptionLabel: i
}) => {
  const r = t(n);
  return r ? e.filter((l) => {
    const o = i(l);
    return t(o).includes(r);
  }) : e;
};
export {
  d as filterOptions
};
